import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-message-dialog',
  template: `
  <a (click)="showDialog()">{{label}}</a>
  <p-dialog [(visible)]="display" [style]="{ width: '90vw' }">
    <pre>{{ message }}</pre>
  </p-dialog>
  `,
  styles: [
    `a { color: blue; text-decoration: underline; cursor: pointer; }`
  ]
})
export class MessageDialogComponent {
  @Input() public label = '(continua)';
  @Input() public properties: string | undefined;
  @Input() public message: string | undefined;

  display = false;

  showDialog() {
    this.display = true;
  }
}
